/**
 * @module app.core
 */

import { autoinject } from 'aurelia-framework';
import { AppLogger } from 'app/shared/lib/logging/app-logger';
import { I18N } from 'aurelia-i18n';

interface UDFSection {
    targetCode: string;
    i18n: string;
    expanded: boolean;
}

@autoinject()
export class ManageUserDefinedFieldsPage {

    ////****************** Fields and Properties ************************************////
    protected sections: UDFSection[] = []

    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        private readonly logger: AppLogger,
        protected readonly i18n: I18N) {
        this.logger.source = this;

        this.sections = [
            { targetCode: 'CD.Member',           i18n: 'cd:member.$',                    expanded: false },
            { targetCode: 'CD.MemberPlan',       i18n: 'cd:member.plan.$long',           expanded: false },
            { targetCode: 'CD.Provider',         i18n: 'cd:provider.$',                  expanded: false },
            { targetCode: 'CD.ProviderGroup',    i18n: 'cd:providerGroup.$long',         expanded: false },
            { targetCode: 'CD.ProviderFacility', i18n: 'cd:providerFacility.$long',      expanded: false },
            { targetCode: 'CD.Product',          i18n: 'cd:member.plan.product.$',       expanded: false },
            { targetCode: 'CD.Drug',             i18n: 'cd:drug.$alt',                   expanded: false },
            { targetCode: 'CD.PharmacyClaim',    i18n: 'cd:member.pharmacy.claim.$long', expanded: false },
            { targetCode: 'CD.LabResult',        i18n: 'cd:labResult.$',                 expanded: false },
            { targetCode: 'CD.Auth',             i18n: 'cd:auth.$',                      expanded: false },
            { targetCode: 'CD.AuthDetail',       i18n: 'cd:auth.detail.$',               expanded: false },
            { targetCode: 'CD.Claim',            i18n: 'cd:claim.$',                     expanded: false },
            { targetCode: 'CD.ClaimDetail',      i18n: 'cd:claim.detail.$',              expanded: false }
        ];
    }

    ////****************** Element References ***************************************////

    ////****************** Functions ************************************************////
    // only load grids if section is expanded
    protected expandSection(targetCode: string): void {
        const foundSection = this.sections.find(section => !section.expanded && section.targetCode === targetCode);
        if(!foundSection) return;
        foundSection.expanded = true;
    }
}
